import { Banner, Button, Container, Body, Title, Stack } from '@optimus-web/core';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';

interface CheckInFieldsHeaderProps {
    onSave: () => void;
}

export const CheckInFieldsHeader = ({ onSave }: CheckInFieldsHeaderProps) => {
    const guestVerificationPhotoEnabled = useFeatureFlag(FeatureFlag.guestVerificationPhotoOciConfigurationEnabled);

    return (
        <Stack vertical spacing="300">
            <Stack vertical spacing="50">
                <Stack distribution="space-between" spacing="50">
                    <Title level={2}>
                        <LocalizedText textKey={TextKey.CheckInForm} />
                    </Title>
                    <Button size="medium" variant="primary" onClick={onSave} type="button">
                        <LocalizedText textKey={TextKey.Save} />
                    </Button>
                </Stack>
                <Container maxWidth="848px">
                    <Body variant="secondary">
                        <LocalizedText textKey={TextKey.CheckInFieldsPageDescription} />
                    </Body>
                </Container>
            </Stack>
            <Banner
                variant="info"
                primaryText={
                    <LocalizedText
                        textKey={
                            guestVerificationPhotoEnabled
                                ? TextKey.CheckInFieldsPageInfoBoxEnhanced
                                : TextKey.CheckInFieldsPageInfoBox
                        }
                    />
                }
            />
        </Stack>
    );
};
